import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import style from './e3dGrpLogin.css'
import { isGrpLoggedInSelector } from '../../../redux/selectors/e3DGrpAuthSelectors'
import { loginStart } from '../../../redux/actions/app/e3DGrpAuth.actions'

const E3DGrpLogin: React.FC = () => {
    const dispatch = useDispatch()
    const grpUserIsLoggedIn = useSelector(isGrpLoggedInSelector)
    const { t } = useTranslation()

    const handleLogin = (): void => {
        dispatch(loginStart())
    }

    if (!grpUserIsLoggedIn) {
        return (
            <div className={style.loginContainer}>
                <button
                    className={style.button}
                    type='button'
                    onClick={() => handleLogin()}
                >
                    {t('login-form.via-avp')}
                </button>
            </div>
        )
    }

    return null
}

export default E3DGrpLogin
